import Vue from 'vue'

Vue.mixin({
  methods: {
    //check this on every page in the app
    pls_app_redirect_url(phone_system){
      if (phone_system == null){
        return false;
      }
      if (phone_system.is_past_due){
        if (phone_system.is_canceled){
          return '/sessions/closed';
        }else{
          return '/sessions/past-due';
        }
      }else{
        try {
          if (
            typeof phone_system.use_users_login == "undefined" ||
            typeof phone_system.use_users_login == "undefined"
          ){
            return '/sessions/signout';
          }
        } catch(e) {
          return '/sessions/signout';
        }
        return false;
      }
    },
    //only check this and redirect on login
    pls_login_redirect_url(phone_system) {
      if (phone_system == null){
        return false;
      }

      //this is the most default redirect, handle these first
      var pls_app_redirect_url = this.pls_app_redirect_url(phone_system);

      if (pls_app_redirect_url){
        return pls_app_redirect_url;
      }else{
        // var eightDaysAgo = parseInt((new Date()).setDate((new Date()).getDate() - 8) / 1000);
        // if (phone_system.stats_28days_minutes_listened < 1400 && phone_system.last_new_media_at == null || this.pls_date_time_to_epoch(phone_system.last_new_media_at) < eightDaysAgo){
        //   return '/media/rtmp';
        // }else if (phone_system.stats_28days_minutes_listened < 1400 && phone_system.num_of_live_notification_subscribers < 6){
        //   return '/live-notifications/subscribers';
        // }else if (this.pls_date_time_to_epoch(phone_system.last_live_notification) < eightDaysAgo){
        //   return '/live-notifications/events';
        // }else if (!phone_system.use_users_login || phone_system.num_of_users < 1){
        //   return '/administrative/users';
        // }else{
          return '/administrative/stats/index';
        // }
      }
    },
    pls_calendly_setup_link(phone_system,located='pls_calendly_setup_link_default_location'){
      if (!phone_system) {
        return 'https://calendly.com/phonelivestreaming/setup?hide_landing_page_details=1&background_color=f8f8f8&primary_color=f08e80&utm_campaign=app_dashbaord_schedule_timewith_us_page&utm_medium=' + located + '&utm_source=app';
      }
      return 'https://calendly.com/phonelivestreaming/setup?hide_landing_page_details=1&background_color=f8f8f8&primary_color=f08e80&utm_campaign=app_dashbaord_schedule_timewith_us_page&utm_medium=' + located + '&utm_source=app&name=' + (phone_system.primary_contact_name || '') + '&email=' + (phone_system.primary_contact_email || '') + '&location=+' + (phone_system.primary_contact_cellphone || '') + '&a1=+' + (phone_system.phone_number || '');
    },
  }
})